/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PolicyCommissionResponseDto = {
    /**
     * Policy commission UUID
     */
    id: string;
    /**
     * Policy UUID
     */
    policyId: string;
    /**
     * Adviser UUID
     */
    adviserId?: string | null;
    /**
     * FAP UUID
     */
    fapId?: string | null;
    /**
     * Commission rule applied
     */
    commissionRuleApplied: string;
    /**
     * Adviser commission percentage used at calculation time
     */
    adviserCommissionPercentageUsed: number;
    /**
     * Adviser override percentage used at calculation time
     */
    adviserOverridePercentageUsed: number;
    /**
     * Adviser broker fee percentage used at calculation time
     */
    adviserBrokerFeePercentageUsed: number;
    /**
     * QA commission percentage used at calculation time
     */
    qaCommissionPercentageUsed: number;
    /**
     * Total commission input
     */
    totalCommissionInput: number;
    /**
     * Broker fee input
     */
    brokerFeeInput: number;
    /**
     * Adviser commission amount
     */
    adviserCommission: number;
    /**
     * Adviser override amount
     */
    adviserOverride: number;
    /**
     * Override recipient name
     */
    overrideName?: string | null;
    /**
     * Adviser broker fee amount
     */
    adviserBrokerFee: number;
    /**
     * FAP commission amount
     */
    businessCommission: number;
    /**
     * FAP broker fee amount
     */
    businessBrokerFee: number;
    /**
     * Commission transaction type at the time the row was created
     */
    transactionType?: PolicyCommissionResponseDto.transactionType | null;
    /**
     * Created timestamp
     */
    createdAt: string;
    /**
     * Updated timestamp
     */
    updatedAt: string;
};
export namespace PolicyCommissionResponseDto {
    /**
     * Commission transaction type at the time the row was created
     */
    export enum transactionType {
        NB = 'NB',
        RENEWAL = 'RENEWAL',
        MTAI = 'MTAI',
        MTAD = 'MTAD',
        MTAN = 'MTAN',
        CANCELLATION = 'CANCELLATION',
    }
}

